import { generatePath, useNavigate } from 'react-router-dom';
import ROUTE from '../../../../constants/route-constants';
import InteractiveButton from '../../../InteractiveButton/InteractiveButton';
import { useTranslation } from 'react-i18next';
import { FaultTextPresenter } from './FaultTextPresenter';

export interface CycleControllerFaultedPresenterProps {
  controllerId: string;
  faultTitle?: string;
}

export const CycleControllerFaultedPresenter = ({ controllerId, faultTitle }: CycleControllerFaultedPresenterProps) => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const onClickBtnHandler = () => {
    const path = generatePath(ROUTE.EDIT_CONTROLLER_SYSTEM_FAULTS, { id: controllerId });
    navigate(path);
  };

  return (
    <div className="c-cycle-controller-faulted-presenter">
      <FaultTextPresenter faultText={t('faults.controllerFaulted')} title={faultTitle} />
      <div className="flex w-full justify-center">
        <div className="flex flex-col gap-2">
          <InteractiveButton onClick={onClickBtnHandler}>
            {t('buttons.goTo', '', {
              navPath: String(`${t('terms.controller.name')} ${t('controllers.settings.tabs.sysFaults')}`),
            })}
          </InteractiveButton>
        </div>
      </div>
    </div>
  );
};
